export const environment = {
  production: false,
      api: 'https://api-senx.vms-systems.com/api' 
};
